export const replaceSubdomainPlaceholder = ({url,subdomains}) => {
    if(!url) return null
    if(!subdomains || subdomains.length === 0) {
        return url;
    }
    const s = subdomains[Math.floor(Math.random() * subdomains.length)];
    return url.replace('{s}', s);
}
